import axios, { AxiosRequestConfig } from "axios";
import { PageAlert } from "capitalrx-components";

interface RequestConfig extends AxiosRequestConfig {
  includeReferrerUrlHeader?: boolean;
}

function getAPIBaseUrl(): string {
  return site.baseUrl.replace(
    "{{protocol}}",
    window.location.protocol).replace("{{hostname}}", window.location.hostname);
}

/**
 * Performs an API request.
 * @param options: The request options.
 * @param authToken: The optional authentication token.
 * @param type: The service to make the outgoing URL
 */
export async function request<T>(
  options: RequestConfig,
  type: "adjudication",
  authToken?: string,
): Promise<T> {
  const { showPageAlert } = PageAlert;

  const client = axios.create({
    baseURL: getAPIBaseUrl(),
    headers: {
      "X-Referrer-Url": window.location.href,
    },
  });

  if (options?.includeReferrerUrlHeader === false) {
    delete client.defaults.headers["X-Referrer-Url"];
  }

  if (authToken) {
    client.defaults.headers.common = {
      Authorization: `Bearer ${authToken}`,
    };
  }

  try {
    const result = await client(options);
    return result.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Skip error alerts when logged out - prevents banners during logout
      if (!authToken) {
        throw error;
      }

      let errorResult: object | string;

      if (error.response) {
        errorResult = error.response;
      } else if (error.message) {
        errorResult = error.message;
      } else if (typeof error === "string") {
        errorResult = {
          data: { message: error },
        };
      } else {
        errorResult = {
          data: { message: "Unknown error type." },
        };
      }

      showPageAlert({ show: true, type: "error", message: errorResult });
    }

    throw error;
  }
}
